var _ellipse, _rect, _path, _path2, _path3, _g, _path4, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkinboxempty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 150,
    viewBox: "0 0 110 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.6458,
    cy: 146.47,
    rx: 32.2771,
    ry: 3.92939,
    fill: "#3A3D40"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 87,
    width: 3,
    height: 59,
    fill: "#0C7A59"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.7186 96.0719C64.257 103.885 54.4727 112.538 56.6771 144.688C80.32 136.252 88.9982 127.109 90.7186 96.0719Z",
    fill: "#0AA776"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0651 89.4317C22.3293 112.663 28.6368 122.789 55.7365 128.249C54.2658 106.156 47.6077 96.8321 18.0651 89.4317Z",
    fill: "#0AA776"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.623 8.62291L74.5912 21.8324L89.8996 23.739L88.5817 39.1093L99.8459 49.6498L89.7452 61.31L92.6626 76.4584L77.6372 79.9546L71.0935 93.9247L56.8827 87.9216L43.3772 95.3772L35.409 82.1677L20.1006 80.2612L21.4185 64.8909L10.1543 54.3503L20.255 42.6902L17.3377 27.5418L32.363 24.0455L38.9068 10.0755L53.1176 16.0786L66.623 8.62291Z",
    fill: "#F8E6A4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_12867_63100)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.0001,
    cy: 52.0001,
    rx: 35.9258,
    ry: 35.9259,
    transform: "rotate(15 55.0001 52.0001)",
    fill: "#FBE067"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4888 55.1677C63.0633 63.6508 47.6682 63.0224 38.5569 55.1677",
    stroke: "#F4A762",
    strokeWidth: 1.57093
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.5573,
    cy: 55.1679,
    rx: 4.0844,
    ry: 4.08445,
    fill: "#EFC254"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.4889,
    cy: 55.1679,
    rx: 4.0844,
    ry: 4.08445,
    fill: "#EFC254"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.6109,
    cy: 48.6643,
    rx: 2.82766,
    ry: 2.8277,
    fill: "#203747"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.4353,
    cy: 48.6643,
    rx: 2.82766,
    ry: 2.8277,
    fill: "#203747"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_12867_63100",
    x: 19.0654,
    y: 16.0653,
    width: 71.8694,
    height: 71.8696,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.920833 0 0 0 0 0.721764 0 0 0 0 0.234045 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_12867_63100"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkinboxempty);
export default __webpack_public_path__ + "static/media/darkinboxempty.bdb0e0889c50d36ec488e2acbb3e5974.svg";
export { ForwardRef as ReactComponent };